export const RoutesConstants = {
  PipeID: 'pipe/:pipeID',
} as const;
